import { useCalcOptionsMarketExecPrice } from "#/hooks/useCalcOptionMarketExecPrice";
import { useCalcPerpsMarketExecPrice } from "#/hooks/useCalcPerpMarketExecPrice";
import { type EstimatedExecPriceProps } from "#/types/fees";

export const useEstimatedExecPriceController = (
  props: EstimatedExecPriceProps,
) => {
  const optionsMarketExecPrice = useCalcOptionsMarketExecPrice(props);
  const perpsMarketExecPrice = useCalcPerpsMarketExecPrice(props);

  return {
    ...(props.kind === "options"
      ? optionsMarketExecPrice
      : perpsMarketExecPrice),
  };
};
